import React from 'react'
import { SlSpinner } from '@shoelace-style/shoelace/dist/react'
import Page from '../Layout/Page'

const PageLoader: React.FC = () => (
  <Page className="flex items-center justify-center">
    <SlSpinner className="text-32" />
  </Page>
)

export default PageLoader
